import { BarChart, Bar, ResponsiveContainer, XAxis, Tooltip, LineChart, Line } from "recharts";
import { SectionHeading } from "@/components/site/ui";
import { TrendingUp, Eye, MousePointer2, Star } from "lucide-react";

const bars = [{ m: "Jan", v: 20 }, { m: "Feb", v: 32 }, { m: "Mar", v: 41 }, { m: "Apr", v: 55 }, { m: "May", v: 63 }, { m: "Jun", v: 78 }];
const line = [{ v: 10 }, { v: 22 }, { v: 30 }, { v: 28 }, { v: 44 }, { v: 60 }, { v: 72 }];

export function Results() {
    return (
        <section className="bg-teal-900 py-20" data-testid="results-section">
            <div className="container-x grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
                <div>
                    <SectionHeading eyebrow="Results & Analytics" title="See Your Growth, Month After Month"
                        subtitle="We track the metrics that matter — visibility, traffic, engagement and enquiries — and share transparent monthly reports." />
                    <div className="mt-8 grid grid-cols-2 gap-4">
                        {[
                            { icon: Eye, label: "Profile Views", note: "Google & social visibility" },
                            { icon: MousePointer2, label: "Website Clicks", note: "Qualified traffic" },
                            { icon: TrendingUp, label: "Enquiries", note: "Calls & form leads" },
                            { icon: Star, label: "Reviews", note: "Reputation growth" },
                        ].map((s) => (
                            <div key={s.label} className="card-teal rounded-xl p-4">
                                <s.icon className="w-5 h-5 text-gold" />
                                <div className="mt-2 font-semibold text-cream text-sm">{s.label}</div>
                                <div className="text-xs text-cream-soft/70">{s.note}</div>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="card-teal rounded-3xl p-6">
                    <div className="flex justify-between items-center mb-4">
                        <span className="text-sm text-cream-soft">Visibility Growth</span>
                        <span className="text-xs font-mono text-growth bg-growth/10 px-2 py-0.5 rounded-full">Illustrative</span>
                    </div>
                    <div className="h-40">
                        <ResponsiveContainer width="100%" height="100%">
                            <BarChart data={bars}>
                                <XAxis dataKey="m" stroke="#F4EAD2" fontSize={11} tickLine={false} axisLine={false} />
                                <Tooltip cursor={{ fill: "rgba(255,255,255,0.05)" }} contentStyle={{ background: "#0B3C36", border: "1px solid #1A5C52", borderRadius: 12, color: "#FBF9F1" }} />
                                <Bar dataKey="v" fill="#E5C378" radius={[6, 6, 0, 0]} />
                            </BarChart>
                        </ResponsiveContainer>
                    </div>
                    <div className="h-24 mt-4">
                        <ResponsiveContainer width="100%" height="100%">
                            <LineChart data={line}><Line type="monotone" dataKey="v" stroke="#10B981" strokeWidth={2.5} dot={false} /></LineChart>
                        </ResponsiveContainer>
                    </div>
                </div>
            </div>
        </section>
    );
}
